export const locale = {
  lang: 'en',
  data: {
    'WIZARD': {
      'TITLEOBLI':'Obligations of the employer',
      'TESTTITULO': 'WIZARD TITLE ',
      'CARGANDO': 'Loading purchased products',
      'SINPRODS': 'You have not purchased this product',
      'LANDING': {
        'PRODUCTO': {

          'DOCUMENTADOR_TITLE':{
            'TITLE1':'Psychosocial risk prevention policy',
            'TITLE2':'Identification and analysis of psychosocial risk factors',
            'TITLE3':'Identification and analysis of psychosocial risk factors, and evaluation of the organizational environment',
            'TITLE4':'Prevention measures and control actions of psychosocial risk factors, of workplace violence and promotion of the favorable organizational environment',
            'TITLE5':'Actions and programs for the prevention of psychosocial risk factors, promotion of the favorable organizational environment, and prevention of workplace violence',
            'TITLE6':'Intervention program with specific assessments and control measures',
            'TITLE7':'Identification of workers who were subject to severe traumatic events and channeling for their attention',
            'TITLE8':'Medical exams and psychological evaluations of workers exposed to workplace violence and / or psychosocial risk factors',
            'TITLE9':'Dissemination and promotion of information to workers',
            'TITLE10':'Registres'
          },
          'GUIA':{
            'TITULO': 'WELCOME TO GUIDE NOM-035-STPS-2018',
            'CHAN_INF':'Loading products',
            'NOM35':{
            'TITULO_LANFIG': 'WELCOME TO NORMA-035',
            'TITULO_PRODUCT2':'Norm-035',
            'ENTRAR':'Start',
            'DONE':'Application date',
            },
            'NOM35PLA':{
            'TITULO_LANFIG': 'WELCOME TO NORMA-035 SILVER',
            'TITULO_PRODUCT2':'Norm-035 silver',
            'ENTRAR':'Start',
            'DONE':'Application date',
            },
            'NOM35BETHE':{
            'TITULO_LANFIG': 'WELCOME TO NORMA-035 BETTER',
            'TITULO_PRODUCT2':'Norm-035 better',
            'ENTRAR':'Start',
            'DONE':'Application date',
            },
            'CURRENT': 'Implementation guide',
            'DESCRIPTION': 'Consult the general information of the standard and answer the information requested from your workplace and the tasks of each employer obligation.',
            'BUTTON': 'START',
            'FINISHED': '',
            'CT_NAME':'Work center: ',
          },
          'ENCUESTADOR':{
            'TITULO': 'WELCOME TO SURVEYER NOM-035-STPS-2018',
            'CURRENT': 'Surveyer',
            'DESCRIPTION' : 'Prepare the required information of the collaborators who will participate in the survey and schedule its launch and communication plan.',
            'BUTTON': 'START',
            'FINISHED': ''
          },
          'EXPEDIENTE':{
            'TITULO': 'WELCOME TO THE RECORD OF NOM-035-STPS-2018',
            'CURRENT': 'Files',
            'DESCRIPTION' : 'Add evidence of clinical care received by collaborators who suffered severe traumatic events.',
            'BUTTON': 'START',
            'FINISHED': ''
          },
          'CENTROS':{
            'TITULO': 'BIENVENIDA AL EXPEDIENTE DE NOM-035-STPS-2018',
            'CURRENT': 'Work centers',
            'DESCRIPTION' : 'Check each work'+ "center's" +'information and response progress from the Implementation Guide, among other things.',
            'BUTTON': 'START',
            'FINISHED': ''
          },
          'RESULTADOS':{
            'TITULO': 'NOM-035 Results',
            'CURRENT': 'Results',
            'DESCRIPTION' : 'Explore and analyze the results of the survey and the final rating of the workplace as established by NOM-035-STPS-2018.',
            'BUTTON': 'START',
            'FINISHED': '',
            'STEPS':{
              '1': 'Inicio',
              '2': 'Información general',
              '3': 'Respuestas',
              '4': 'Tablero',
              '5': 'Por categoria',
              '6': 'Por dominio',
              '7': 'Calificacion final',
              '8': 'Respuestas',
              '9': 'Respuestas-2',
              '10': 'Respuestas-3',
              '11': 'Información general'
            }
          }
        },

      },
      'MODAL':{
        'LABEL01':'Loading...'
      },
      'CT_INFORMACION':{
        'Label01':'Please, complete the following information about your center work:',
        'Label02':'',
        'TABLE':{
          'LabelTable01':'Objective',
          'LabelTable02':'Main activities'
        },
        'LISTA':{
          'TITULO': 'Company work centers',
          'SUBTI': 'See your work centers information',
          'CARGANDO': 'Loading stored work centers',
          'NOCENTROS': 'You have not loaded any work center yet',
          'NODATA': ' You have not loaded any database',
          'CENTRO': {
            'MOREINFO': 'Click here to see more details',
            'TITULO': 'Work center information',
            'NOMBRE': 'Name',
            'ACTIVIDAD': 'Main activity',
            'RESPO': 'Manager name',
            'EMAIL': 'Email',
            'EMAILRS': "Responsable trade name email's",
            'DOMI': 'Address',
            'ACCIONES': 'Actions',
            'AUTOLOGIN': 'See implementation guide progress',
            'CTADV': 'Progress by work center',
            'PDF':'Create PDF '
          }
        }
      },
      'PDF':{
        'BTN':'Create PDF evidence '
      },
      'TIMELINE':{
        'TIMELINE':'Timeline',
        'LABEL01':'Implemetantion guide progress',
        'STEPS':{
          'STEP01': 'Fase 1' ,
          'STEP02': '23/10/2019 to 23/10/2020' ,
          'STEP03': 'Fase 2' ,
          'STEP04': 'from 23/10/2020 ' ,
        },
        'TABLE':{
          'LABEL01':'Request',
          'LABEL02':'Activity',
          'LABEL03':'Deliverable'

        }

      },
      'STEPSTAT': {
        'LOCK': 'Step locked',
        'PEND': 'Step open',
        'COMP': 'Step complete'
      },
      'NOPRODUCTS': {
        'TITULO': 'Your company does not have added products',
        'SUBTI': 'Information about ofert'
      },
      'MENU_GUIA': {
        'TITULO': 'CGO NOM-035-STPS-2018',
        'MENU': {
          'MN1': {
            'TITULO': 'General view',
          },
          'MN2': {
            'TITULO': 'General aspects',
          },
          'MN3': {
            'TITULO': 'Objective',
          },
          'MN4': {
            'TITULO': 'Field of application',
          },
          'MN5': {
            'TITULO': 'References',
          },
          'MN6': {
            'TITULO': 'Definition about norm',
          },
          'MN7': {
            'TITULO': 'Definition about plataform',
          },
          'MN8': {
            'TITULO': 'Employer Obligations',
          },

          'MN9': {
            'TITULO': 'Psychosocial risk prevention policy',
          },
          'MN10': {
            'TITULO': '16-50 survey collaborators',
          },
          'MN11': {
            'TITULO': 'More 50 collaborators survey ',
          },
          'MN12': {
            'TITULO': 'Prevention and control measures',
          },
          'MN13': {
            'TITULO': 'Complaints and denunciations channel',
          },
          'MN14': {
            'TITULO': 'Preventive actions and programs',
          },
          'MN15': {
            'TITULO': 'Intervention program with evaluations and control measures',
          },
          'MN16': {
            'TITULO': 'Survey of severe traumatic events',
          },
          'MN17': {
            'TITULO': 'Medical exams and psychological evaluations',
          },
          'MN18': {
            'TITULO': 'Dissemination and promotion of information',
          },
          'MN19': {
            'TITULO': 'Registers',
          },
          'MN20': {
            'TITULO': 'Support documents',
          },
          'MN21': {
            'TITULO': 'Reference guide I',
          },
          'MN22': {
            'TITULO': 'Reference guide II',
          },
          'MN23': {
            'TITULO': 'Reference guide III',
          },
          'MN24': {
            'TITULO': 'Reference guide IV',
          },
          'MN25': {
            'TITULO': 'Reference guide V',
          },
          'MN26': {
            'TITULO': 'Pending tasks',
          },
          'MN27': {
            'TITULO': 'Obligations of collaborators',
          },
          'MN28': {
            'TITULO': 'Work center information',
          },
          'MN29': {
            'TITULO': 'Time-line',
          },


        }
      },
      'PATRON': {
        '0':{
          'SECCION':'Psychosocial risk prevention policy'
        },
        '1':{
          'SECCION':'16-50 collaborators survey'
        },
        '2':{
          'SECCION':'More 50 collaborators survey'
        },
        '3':{
          'SECCION':'Complaints and denunciations channel'
        },
        '4':{
          'SECCION':'Preventive actions and programs'
        },
        '5':{
          'SECCION':'Intervention program with evaluations and control measures'
        },
        '6':{
          'SECCION':'Survey of severe traumatic events'
        },
        '7':{
          'SECCION':'Medical exams and psychological evaluations'
        },
        '8':{
          'SECCION':'Dissemination and promotion of information '
        },
        '9':{
          'SECCION':'Logs'
        },
      },
      'DEFINICIONES_NORMA':{
        'SPAN01':'For the purposes of NOM-035-STPS-2018, the following definitions are considered:',
        'SPAN02':'For the purposes of the platform, the following definitions are considered:',
        'DEF1':{
          'TITLE_DEF': "1.- Severe Traumatic Event",
          'DEF': 'The one experienced during or on the occasion of work that is characterized by the occurrence of death or that represents a real danger to the physical integrity of one or several people and that can generate post-traumatic stress disorder for those who suffer or witness it. Some examples are: explosions, landslides, large fires; serious or fatal accidents, assaults with violence, kidnappings and homicides, among others.',
        },
        'DEF2':{
          'TITLE_DEF': "2.- Social support",
          'DEF': "Actions to improve social relations at work in which mutual support is promoted in the solution of work problems among workers, superiors and / or subordinates. Some examples of measures to constitute practical and timely social support in the workplace are: strengthening the supervisors-workers relationship; foster mutual help among workers; promote cultural and sports activities, and provide direct help when necessary, among others",
        },
        'DEF3':{
          'TITLE_DEF': "3.- Labor authority",
          'DEF': " The competent administrative units of the Secretariat that perform inspection and surveillance functions in the field of occupational safety and health, and those corresponding to the federal entities, which act in aid of those"
        },
        'DEF4':{
          'TITLE_DEF': "4.- Work center",
          'DEF': "The place or places, such as buildings, premises, facilities and areas, where activities of exploitation, exploitation, production, marketing, transport and storage or provision of services are carried out, in which people who are subject to a working relationship work."

        },
        'DEF5':{
          'TITLE_DEF': "5.- Occupational health and safety diagnosis",
          'DEF': "The identification of unsafe or dangerous conditions; of physical, chemical or biological agents or of ergonomic or psychosocial risk factors capable of modifying the conditions of the work environment; of the dangers surrounding the workplace, as well as the regulatory requirements regarding occupational safety and health that are applicable"
        },
        'DEF6':{
          'TITLE_DEF': "6.- Favorable Organizational Environment",
          'DEF': "The one in which the sense of belonging of the workers to the organization is promoted; training for the proper performance of the tasks entrusted; the precise definition of responsibilities for workers in the workplace; proactive participation and communication between workers; the adequate distribution of workloads, with regular working hours in accordance with the Federal Labor Law, and the evaluation and recognition of performance."
        },
        'DEF7':{
          'TITLE_DEF': "7.- Psychosocial Risk Factors",
          'DEF': "Those who can cause anxiety disorders, non-organic sleep-wake cycle and severe stress and adaptation, derived from the nature of the job functions, the type of workday and exposure to severe traumatic events or acts of labor violence to the worker, for the work developed. They understand dangerous and unsafe conditions in the work environment; workloads when they exceed the worker's capacity; lack of control over work (possibility of influencing the organization and development of work when the process allows it); working hours higher than those provided for in the Federal Labor Law, rotation of shifts that include night shifts and night shifts without recovery and rest periods; interference in the work-family relationship, and negative leadership and negative relationships at work."
        },'DEF8':{
          'TITLE_DEF': "8.- Prevention measures and control actions",
          'DEF': "Those actions that are adopted to prevent and / or mitigate psychosocial risk factors and, where appropriate, to eliminate practices opposed to the favorable organizational environment and acts of labor violence, as well as the actions implemented to monitor them."
        },'DEF9':{
          'TITLE_DEF': "9.- Psychosocial risk prevention policy",
          'DEF': "The declaration of principles and commitments established by the employer to prevent psychosocial risk factors and labor violence, and to promote a favorable organizational environment, in order to develop a culture in which decent or decent work is sought, and the continuous improvement of working conditions."
        },
        'DEF10':{
          'TITLE_DEF': "10.- Worker",
          'DEF': "The natural person who lends to another, physical or moral, a subordinate personal work."
        },'DEF11':{
          'TITLE_DEF': "11.- Job",
          'DEF': "Any human, intellectual or material activity, regardless of the degree of technical preparation required by each profession or trade."
        },'DEF12':{
          'TITLE_DEF': "12.- Work violence",
          'DEF': "Those acts of harassment, harassment or ill-treatment against the worker, which can damage his integrity or health."
        }
      },
      'DEFINICIONES_TABLA':{
        'DEF1':{
        'TITLE_DEF':'1.- Provision',
        'DEF':'It is a prescription adopted by STPS to establish a type of regulation with a regulatory nature to be fulfilled by the employer.'
        },
        'DEF2':{
          'TITLE_DEF':'2.- GPTW definition',
          'DEF':'Explanation by GPTW to summarize what can be done to comply with the provision.'
        },
        'DEF3':{
          'TITLE_DEF':'3.- Support',
          'DEF':'Example of documents that can be consulted on the platform and videos with ideas of what can be shown as evidence for compliance with the provision.'
        },
        'DEF4':{
          'TITLE_DEF':'4.- Acceptance criteria',
          'DEF':'A set of guidelines that establish the compliance characteristics of a provision and that are evaluated by a representative of an accredited verification unit and approved to verify the degree of compliance with NOM-035-STPS-2018.'
        },
        'DEF5':{
          'TITLE_DEF':'5.- Task',
          'DEF':'Activities to be carried out by the work center representative in compliance with the provision and that includes a type of documentary verification (evidence) or interview as applicable. Each task is evaluated by a representative of a work center that indicates whether or not it meets or does not apply.'
        },

      },
      'ASPECTOS_GENERALES':{
        'TITLE':'General aspects',
        'ASP1':{
          'TITLE':'Objective'
        },
        'ASP2':{
          'TITLE':'Field of application '
        },
        'ASP3':{
          'TITLE':'References'
        },
        'ASP4':{
          'TITLE':'Definition about norm'
        },
        'ASP5':{
          'TITLE':'Definition about plataform'
        },

      },
      'OBJETIVO':{
        'TITLE':'Manual NOM-035-STPS-2018',
        'SUBTITLE':'By Great Place to Work',
        'DESCRIPTION':'NOM-035-STPS-2018 is an instrument that allows the identification and analysis of psychosocial risk factors in the workplace in a general way; as well as evaluate the organizational environment in which workers carry out their activities.',
        'MENU':{
          'MAINTITLE':'Particulars',
          'TITLE1':'Promotion of a favorable organizational environment.',
          'TITLE2':'Prevention of psychosocial risk factors.',
          'TITLE3':'Prevention of workplace violence.',
          'TITLE4':'Disseminate the psychosiocial risk prevention policy in the workplace.',
        }
      },
      'CAMPO_APLICACION':{
        'TITLE':'This Official Mexican Standard applies throughout the national territory and applies to all workplaces, in accordance with the following:',
         'MENU':{
           'SUB1':'a) For work centers where up to fifteen workers work they must comply with the provisions of numerals 5.1, 5.4, 5.5, 5.7, 8.1 and 8.2 of this Standard;',
           'SUB2':'b) For work centers where they work between sixteen and fifty workers, they must comply with numerals 5.1, 5.2, 5.4 to 5.8, 7.1, subsection a), 7.2, 7.4 to 7.9, and Chapter 8 of this Standard',
           'SUB3':'c) For work centers where more than 50 workers work, they must comply with numerals 5.1, 5.3 to 5.8, 7.1, subsection b), 7.2 to 7.9 and Chapter 8 of this Standard.',
         },
         'SUBTITLE':'Those work centers that have a Certificate of compliance with the Mexican standard NMX-R-025-SCFI-2015, in force, will give that condition compliance with the following obligations and numbers:',
         'MENUSUB':{
           'SUB1':'5.1 subsection b), 8.1, subsection b), 8.2 subsections a), subsection 2), e) and g); 5.7 subsection d) ',
         }
      },
      'REFERENCIAS':{
        'TITLE':'For the correct interpretation and application of this Standard, the following official Mexican standards and the current Mexican standard should be consulted, or those that replace them:',
        'CONTENT':{
          'CONTENT1':'3.1 NOM-019-STPS-2011, Constitution, integration, organization and operation of health and safety commissions.',
          'CONTENT2':'3.2 NOM-030-STPS-2009, Preventive health and safety services at work-Functions and activities.',
          'CONTENT3':'3.3 NMX-R-025-SCFI-2015, On Labor Equality and Non-Discrimination.'
        }
      },
      'OBLIGACIONES':{

        'TITLE':'Employer Obligations',
        'CONTENT':{
          'CONTENT1':'Psychosocial risk prevention policy',
          'CONTENT2':'16-50 survey collaborators',
          'CONTENT3':'More 50 collaborators survey',
          'CONTENT4':'Prevention and control measures',
          'CONTENT5':'Complaints and denunciations channel',
          'CONTENT6':'Preventive actions and programs',
          'CONTENT7':'Intervention program with evaluations and control measures',
          'CONTENT8':'Survey of severe traumatic events',
          'CONTENT9':'Medical exams and psychological evaluations',
          'CONTENT10':'Dissemination and promotion of information',
          'CONTENT11':'Registers'
        }

      },
      'COLABORADORES':{
        'TITLE':'Obligations of collaborators.',
        'SUBTITLE':'Control detail',
        'TABLE_LABEL01':'Provision'
      },
      'DOCUMENTO_SOPORTE':{
        'TITLE':'Support documents',
        'CONTENT1':{
          'DOC1':'Reference guide I',
          'DOC2':'Reference guide II',
          'DOC3':'Reference guide III',
          'DOC4':'Reference guide IV',
          'DOC5':'Reference guide V',
        }
      },
      'DOCUMENTADOR':{
        'LABEL01':'Play video',
        'LABEL02':' Click ',
        'LABEL03':' to consult the oficial NOM-035-STPS-2018 ',
        'LABEL04':'here',
        'LABEL05':'Provision 6.1 - 6.7',

      },
      'TABLE_STEP':{
        'TITLE':'Control detail',
        'LINK':'Click here to more information',
        'TABLE1':{
          'DIS':'Provision',
          'DEF':'Definition GPTW',
          'APOYO': 'Support',
          'CT_ACEPT':'Acceptance criteria'
        },
        'TABLE2':{
          'EST':'Status',
          'DATE':'Date',
          'NUM': 'Numeral',
          'DES':'Task description',
          'EVD':'Evidence',
          'OBS':'Observations',
          'DOC':'Support',
          'FILE': 'Load files',
          'TASK': 'Add task',
          'ACT': 'Activity',
          'CHECK': 'Checked',
        },
        'SPAN01':'Add more tasks'
      },
      'LISTATAREAS':{
        'LABEL01':'Description',
        'LABEL02':'Status',
        'LABEL03':'Observations',
        'LABEL04':'See',

      },
      'MENSAJES':{
        'ADVICE1':'Evidence can not be empety',
        'ADVICE2':'Upload successful',
        'ADVICE3':'Something goes wrong',
        'ADVICE4':'¿Are yo usure you wanna create a new task?',
        'ADVICE5':'Field empety',
        'ADVICE6':'Updating',
        'ADVICE7':'File upload successfuly',
        'ADVICE8':'You can not delete files if your task is completed',
        'ADVICE9':'File delete successfuly',
        'ADVICE10':'Empety fields',
        'ADVICE11':'Field can not be empety',
        'ADVICE12':'Cancel',
        'ADVICE13':'Yes',
        'ADVICE14':'¿Are yo usure you wanna create a new activity?'
      },
      'GUIA1':{
        'title': 'Reference guide I',
        'subtitle': 'EXAMPLE OF QUESTIONNAIRE TO IDENTIFY WORKERS WHO WERE SUBJECT TO SEVERE TRAUMATIC EVENTS',
        'content': 'The content of this guide is a complement to the better understanding of this Standard and is not mandatory.',
        'content2': 'In this guide, an example of a questionnaire is presented that allows the identification of workers who have been subjected to severe traumatic events and who require clinical assessment.',
        'def':'QUESTIONNAIRE TO IDENTIFY WORKERS WHO WERE SUBJECT TO SEVERE TRAUMATIC EVENTS Mark an "X" to the answer indicated',
        'SEC':'Question section',
        'RES':'YES / NO answer',
        'SURVEY':{
          'QUES1':'I.- Severe Traumatic Event',
          'QUESTIONS1':{
              'ques1': 'Have you ever witnessed or suffered, during or on the occasion of work, an event such as the following:',
              'ques2': 'Accident resulting in death, loss of a member or a serious injury?',
              'ques3': 'Assaults?',
              'ques4': 'Violent acts that resulted in serious injuries?',
              'ques5' : 'Kidnappings?',
              'ques6': 'Threats?',
              'ques7': 'Any other that puts your life or health at risk, and / or that of other people?'
          },
          'QUES2':'II.- Persistent memories about the event (during the last month):',
          'QUESTIONS2':{
              'ques1': '¿He has had recurring memories about the event that causes discomfort?',
              'ques2': '¿He has had recurring dreams about the event, which cause him discomfort?',
          },
          'QUES3':'III.- Effort to avoid similar or associated circumstances to the event (during the last month):',
          'QUESTIONS3':{
              'ques1': 'Have you struggled to avoid all kinds of feelings, conversations or situations that may remind you of the event?',
              'ques2': 'Have you struggled to avoid all kinds of activities, places or people that motivate memories of the event?',
              'ques3': 'Have you had difficulty remembering any important part of the event?',
              'ques4': 'Has your interest in your daily activities decreased?',
              'ques5': '¿Se ha sentido usted alejado o distante de los demás?',
              'ques6': 'Have you felt distant or distant from others?',
              'ques7': '¿He has had the impression that his life will be shortened, that he will die before other people or that he has a limited future?',
          },
          'QUES4':'IV Affectation (during the last month):',
          'QUESTIONS4':{

              'ques1': 'Have you had trouble sleeping?',
              'ques2': '¿You have been particularly irritable or given courage?',
              'ques3': '¿Has had difficulty concentrating?',
              'ques4': '¿Has been nervous or constantly on alert?',
              'ques5': '¿He has been easily startled by anything?',
          }


        }
      },
      'Guia2':{
        'title': 'Reference guide II',
        'subtitle': 'IDENTIFICATION AND ANALYSIS OF PSYCHOSOCIAL RISK FACTORS',
        'content': 'The content of this guide is a complement to the better understanding of this Standard, and is not mandatory, it can be used by those work centers that have up to 50 workers. The identification and analysis of the psychosocial risk factors to which Section 8.1, subsection a) of this Standard, may be carried out by applying the following questionnaire.',
        'content2': 'QUESTIONNAIRE TO IDENTIFY PSYCHOSOCIAL RISK FACTORS IN WORK CENTERS',
        'indica1': 'To answer the following questions consider the conditions of your workplace, as well as the amount and pace of work.',
        //indicacion despues de la pregunta 09//
        'indica2': 'The following questions are related to the activities you do in your work and the responsibilities you have.',
        //indicacion despues de la pregunta 13 //
        'indica3': 'The following questions are related to the time devoted to their work and their family responsibilities.',
        //indicacion despues de la pregunta 17 //
        'indica4': 'The following questions are related to the decisions you can make in your work',
        //indicacion despues de la pregunta 22 //
        'indica5': 'The following questions are related to the training and information you receive about your work.',
        //indicacion despues de la pregunta 27 //
        'indica6': 'The following questions refer to relationships with your co-workers and your boss.',
        //indicacion despues de la pregunta 40 //
        'indica7': 'The following questions are related to customer and user service.',
        //indicacion despues de la pregunta SI/NO //
        'indica8': 'If your answer was "YES", answer the following questions. If your answer was "NO" go to the questions in the next section.',
        //indicacion despues de la pregunta SI/NO II//
        'indica9': 'If your answer was "YES", answer the following questions. If your answer was "NO", you have concluded the questionnaire.',
        //indicacion despues de la pregunta SI/NO II//
        'indica10': 'The following questions are related to the attitudes of the workers you supervise. ',
         'labelp':'Im the boss of other workers.',
        'tablas':{//inicio tabla1
            'opc':{
              'opc1': 'Always',
              'opc2': 'Usually',
              'opc3': 'Sometimes',
              'opc4': 'Rarely',
              'opc5': 'Never',
                  },
             'preguntas':{
               //tabla1
               'pre1': 'My job requires me to make a lot of physical effort',
                   'pre2': 'Im worried about having an accident at my job',
                   'pre3': 'I consider that the activities I do are dangerous',
                   'pre4': 'For the amount of work I have, I have to stay extra time for my shift',
                   'pre5': 'For the amount of work I have, I have to work non-stop',
                   'pre6': 'I think it is necessary to maintain an accelerated work pace',
                   'pre7': 'My work requires me to be very focused',
                   'pre8': 'My job requires me to memorize a lot of information',
                   'pre9': 'My work requires that I address several issues at the same time',
                  //tabla 2
                   'pre10': 'In my work I am responsible for things of great value',
                   'pre11': 'I answer to my boss for the results of my entire work area',
                   'pre12': 'In my work they give me contradictory orders',
                   'pre13': 'I consider that in my work they ask me to do unnecessary things',
                  //tabla 3
                   'pre14': 'I work overtime more than three times a week',
                   'pre15': 'My work requires me to work on rest days, holidays or weekends',
                   'pre16': 'I think that the time at work is a lot and it hurts my family or personal activities',
                   'pre17': 'I think about family or personal activities when Im at work',
                  //tabla 4
                   'pre18': 'My work allows me to develop new skills',
                   'pre19': 'In my work I can aspire to a better position',
                   'pre20': 'During my work day I can take breaks when I need them',
                   'pre21': 'I can decide the speed at which I perform my activities in my work',
                   'pre22': 'I can change the order of the activities I do in my work',
                  //tabla5
                   'pre23': 'They inform me clearly what my functions are',
                   'pre24': 'They clearly explain the results that I should get in my work',
                   'pre25': 'They inform me with whom I can solve problems or work issues',
                   'pre26': 'They allow me to attend training related to my work',
                   'pre27': 'I receive useful training to do my job',
                  //tabla6
                   'pre28': 'My boss takes into account my views and opinions',
                   'pre29': 'My boss helps solve the problems that arise at work',
                   'pre30': 'I can trust my coworkers',
                   'pre31': 'When we have to do teamwork, colleagues collaborate',
                   'pre32': 'My coworkers help me when I have difficulties',
                   'pre33': 'In my work I can express myself freely without interruptions',
                   'pre34': 'I receive constant criticism of my person and / or work',
                   'pre35': 'I receive teasing, slander, defamation, humiliation or ridicule',
                   'pre36': 'My presence is ignored or excluded from work meetings and in decision-making',
                   'pre37': 'Work situations are manipulated to make me look like a bad worker',
                   'pre38': 'My work successes are ignored and attributed to other workers',
                   'pre39': 'I am blocked or impeded by the opportunities I have to get promotion or improvement in my work',
                   'pre40': 'I have witnessed acts of violence in my workplace',
                  //pregunta SI/ NO 40
                  'preg*':{
                       'pre': 'In my work I must provide service to clients or users:',
                       'opc1': 'YES',
                       'opc2': 'NO',
                          },
                  //Tabla 7
                  'pre41': 'I serve very angry customers or users',
                  'pre42': 'My job requires me to take care of people in need of help or sick',
                  'pre43': 'To do my job I must show feelings different from mine',
                  //pregunta SI/ NO 43
                  'preg*2':{
                       'pre': 'I am the head of other workers:',
                       'opc1': 'YES',
                       'opc2': 'NO',
                          },
                  //Tabla 8
                   'pre44': 'They communicate work issues late',
                   'pre45': 'Difficult to achieve the results of the work',
                   'pre46': 'Ignore suggestions to improve your work',
                  } // Fin preguntas
                }//fin tabla

      },
      'Guia3':{
        'title': 'Reference guide III',
        'subtitle': 'IDENTIFICATION AND ANALYSIS OF PSYCHOSOCIAL RISK FACTORS AND EVALUATION OF THE ORGANIZATIONAL ENVIRONMENT IN THE WORK CENTERS',
        'content': 'The content of this guide is a complement to the better understanding of this Standard, and is not mandatory, it can be used by those work centers that have more than 50 workers. The identification and analysis of psychosocial risk factors and the evaluation of the organizational environment referred to in section 8.1, subsection b) of this Standard, may be carried out by applying the following questionnaire',
        'content2': 'QUESTIONNAIRE TO IDENTIFY PSYCHOSOCIAL RISK FACTORS AND ASSESS THE ORGANIZATIONAL ENVIRONMENT IN WORK CENTERS',
        'TABLES':{
          'LABEL01':'Never',
          'LABEL02':'Almost never',
          'LABEL03':'Sometimes',
          'LABEL04':'Almost always',
          'LABEL05':'always',

          'LABEL06':'YES',
          'LABEL07':'NO',
        },
        'PREGUNTAS':{

          'SECCION1_LABEL01':'In my work I must provide service to clients or users:',
          'SECCION1_LABEL02':' If your answer was "YES", answer the following questions. If your answer was "NO", you have concluded the questionnaire.',
          'SECCION1_LABEL03':'If your answer was "YES", answer the following questions. If your answer was "NO" go to the questions in the next section.',
          'SECCION1_LABEL04':'The following questions are related to the attitudes of the workers you supervise.',

          'SECCION2_LABEL01':'In my work I must provide service to clients or users:',
          'SECCION2_LABEL02':' If your answer was "YES", answer the following questions. If your answer was "NO", you have concluded the questionnaire.',
          'SECCION2_LABEL03':' If your answer was "YES", answer the following questions. If your answer was "NO" go to the questions in the next section.',
          'SECCION2_LABEL04':'The following questions are related to the attitudes of the people you supervise.',

          'SECCION1':{
            'DESCRIPTION':'To answer the following questions, consider the environmental conditions of your workplace.',
            'QUES1':'The space where I work allows me to perform my activities in a safe and hygienic way',
            'QUES2':'My job requires me to make a lot of physical effort',
            'QUES3':' I am worried about having an accident at my job',
            'QUES4':'I consider that in my work the rules of safety and health at work apply',
            'QUES5':'	I consider that the activities I do are dangerous',
          },
          'SECCION2':{
            'DESCRIPTION':'To answer the following questions, think about the amount and pace of work you have.',
            'QUES1':'For the amount of work I have, I have to stay extra time for my shift',
            'QUES2':'	For the amount of work I have I must work without stopping',
            'QUES3':'I think it is necessary to maintain an accelerated work pace',
          },
          'SECCION3':{
            'DESCRIPTION':'The following questions are related to the mental effort your job demands.',
            'QUES1':'My job requires me to be very focused',
            'QUES2':'My job requires me to memorize a lot of information',
            'QUES3':'In my work I have to make difficult decisions very quickly',
            'QUES4':'My job requires that I attend several issues at the same time'
          },
          'SECCION4':{
            'DESCRIPTION':'The following questions are related to the activities you do in your work and the responsibilities you have.',
            'QUES1':'	In my work I am responsible for things of great value',
            'QUES2':'	I answer to my boss for the results of my entire work area',
            'QUES3':'At work they give me contradictory orders',
            'QUES4':'	I consider that in my work they ask me to do unnecessary things'
          },
          'SECCION5':{
            'DESCRIPTION':'The following questions are related to your work day.',
            'QUES1':'I work overtime more than three times a week',
            'QUES2':'My job requires me to work on rest days, holidays or weekends	',
            'QUES3':'I consider that the time at work is a lot and it hurts my family or personal activities ',
            'QUES4':' I have to attend to work matters when I am at home',
            'QUES5':' I think of family or personal activities when I am at work',
            'QUES6':' I think my family responsibilities affect my work'
          },
          'SECCION6':{
            'DESCRIPTION':' The following questions are related to the decisions you can make in your work.',
            'QUES1':'My work allows me to develop new skills',
            'QUES2':'In my work I can aspire to a better position',
            'QUES3':'During my work day I can take breaks when I need them ',
            'QUES4':'I can decide how much work I do during the workday',
            'QUES5':'I can decide the speed at which I do my work activities ',
            'QUES6':'I can change the order of the activities I do in my work'
          },
          'SECCION7':{
            'DESCRIPTION':'The following questions are related to any type of change that occurs in your work (consider the last changes made).',
            'QUES1':'The changes that occur in my work make my work difficult	',
            'QUES2':'When there are changes in my work my ideas or contributions are taken into account	',
          },
          'SECCION8':{
            'DESCRIPTION':'The following questions are related to the training and information provided about your work',
            'QUES1':'They clearly inform me what my functions are	',
            'QUES2':'They clearly explain the results that I must obtain in my work	',
            'QUES3':'They clearly explain the objectives of my work',
            'QUES4':'They inform me with whom I can solve problems or work issues',
            'QUES5':'They allow me to attend training related to my work ',
            'QUES6':'I receive useful training to do my job'
          },
          'SECCION9':{
            'DESCRIPTION':'The following questions are related to the boss (s) with whom you have contact. ',
            'QUES1':'My boss helps organize the work better	',
            'QUES2':'My boss takes my views and opinions into account',
            'QUES3':'My boss communicates work related information to me on time',
            'QUES4':'The guidance my boss gives me helps me do my job better',
            'QUES5':'My boss helps solve the problems that arise at work'
          },
          'SECCION10':{
            'DESCRIPTION':'The following questions refer to relationships with peers ',
            'QUES1':'I can trust my coworkers	',
            'QUES2':'Between colleagues we solve work problems in a respectful way	',
            'QUES3':'In my work they make me feel part of the group ',
            'QUES4':'When we have to do teamwork, colleagues collaborate',
            'QUES5':'My coworkers help me when I have difficulties'
          },
          'SECCION11':{
            'DESCRIPTION':'The following questions are related to the information you receive about your job performance, recognition, sense of belonging and the stability your job offers you.',
            'QUES1':'They inform me about what I do well in my work',
            'QUES2':'The way they evaluate my work in my workplace helps me improve my performance',
            'QUES3':'	My salary is paid on time at my workplace',
            'QUES4':'The payment I receive is what I deserve for the work I do',
            'QUES5':'If I get the expected results in my work, they reward me or recognize me',
            'QUES6':'People who do the job well can grow at work',
            'QUES7':'I consider that my work is stable',
            'QUES8':'In my work there is continuous staff turnover ',
            'QUES9':'I feel proud to work in this workplace',
            'QUES10':'I feel committed to my work'
          },
          'SECCION12':{
            'DESCRIPTION':'The following questions are related to acts of workplace violence (abuse, harassment, harassment, psychological harassment).',
            'QUES1':'En mi trabajo puedo expresarme libremente sin interrupciones	',
            'QUES2':'I receive constant criticism of my person and / or work',
            'QUES3':'I receive teasing, slander, defamation, humiliation or ridicule',
            'QUES4':'My presence is ignored or excluded from work meetings and in decision making',
            'QUES5':'Work situations are manipulated to make me look like a bad worker',
            'QUES6':'My work successes are ignored and attributed to other workers',
            'QUES7':'	They block or impede the opportunities I have to get promotion or improvement in my work',
            'QUES8':'I have witnessed acts of violence in my workplace '
          },
          'SECCION13':{
            'DESCRIPTION':'The follow questions have relationship with clients atention and users. ',
            'QUES1':'I serve very angry customers or users',
            'QUES2':'MMy job requires me to take care of people in need of help or si	',
            'QUES3':'To do my job I have to show different feelings from mine',
            'QUES4':'My job requires me to deal with situations of violence '
          },
          'SECCION14':{
            'DESCRIPTION':'I am head of other workers',
            'QUES1':'They communicate work issues late',
            'QUES2':'Difficult to achieve work results	',
            'QUES3':'They cooperate little when needed ',
            'QUES4':'They ignore suggestions to improve their work'
          },

        }
      },
      'Guia4':{
        'TITLE':'Reference guide IV',
        'SUBTITLE':'EXAMPLE OF PSYCHOSOCIAL RISK PREVENTION POLICY',
        'CONTENT':'The content of this guide is a complement to the better understanding of this Standard, and is not mandatory.',
        'MAIN_CONTENT':{
          'TITLE':'PSYCHOSOCIAL RISK PREVENTION POLICY',
          'PAF1':'In this workplace (Corporate Name) in relation to the prevention of psychosocial risk factors; the prevention of workplace violence, and the promotion of a favorable organizational environment, the following commitments are assumed:',
          'PAF2':'It is the obligation of supervisors, managers and directors to apply this policy and lead by example; Acts of workplace violence are not tolerated, as are any incidents that promote psychosocial risk factors or actions against the favorable organizational environment; Measures aimed at the prevention of psychosocial risk factors are applied; the prevention of workplace violence, and the promotion of a favorable organizational environment, to prevent its adverse consequences',
          'PAF3':'There is a fair care procedure, which does not allow retaliation and avoids abusive or unfounded claims, and guarantees the confidentiality of cases;',
          'PAF4':'Awareness actions, information and training programs are carried out.',
          'PAF5':'Prevention policies and prevention measures are effectively disclosed; All workers participate to establish and implement this policy in the workplace; It respects the exercise of the rights of staff to observe their beliefs or practices or to meet their needs related to race, sex, religion, ethnicity or age or any other condition that may give rise to discrimination, and Participation spaces are created and consultation, taking into account the ideas of workers and employees.',
          'NOTA':{
            'DES':'Note: The policy must indicate to those responsible (with capacity for its application) and the resources available to comply with the policies at all levels of the organization; the assignment of responsibilities to both people and work teams, who receive the',
            'NOT1':'1. To favor a favorable organizational environment, the workplace includes:',
            'NOT1_P':{
              'A':'a) They hold meetings with the workers so that everyone has the opportunity to express their doubts, concerns, complaints related to their work',
              'B':'b) They keep work areas clean; as well as common areas: dining room, bathrooms, toilets, access;',
              'C':'c) Treat coworkers, bosses, subordinates, visitors, suppliers, customers with kindness and courtesy;',
              'D':'d) They deal with all cases related to teasing, ill-treatment, discrimination, etc., and where appropriate, they are sanctioned;',
              'E':'e) They carry out medical examinations to the new personnel to try and maintain their health',
              'F':'f) They carry out psychological and / or psychometric exams to place each worker in the position for which they have appropriate skills and preparation;',
              'G':'g) Make internal promotion plans, and',
              'H':'h) Train all staff for the performance of their duties, their safety and development',
            },
            'NOT2':'2. In this work center, to promote the sense of belonging of the workers to the organization, it is emphasized that all and all workers and employees are important to the work center, since it cannot work if it is not counted with personnel from the cleaning, through the operative, administrative and even the manager.',
            'NOT3':'3. This work center, to achieve the adequate performance of the tasks entrusted, provides its workers and employees with the training established in the Federal Labor Law, according to the activities they perform.',
            'NOT4':'4. In this work center, to achieve the precise definition of responsibilities for workers, the organization manuals and job descriptions that indicate the specific responsibilities of each job position are disseminated and promoted.',
            'NOT5':'5. To achieve proactive participation and communication among its members, this work center publishes on announcements, news and notices of interest to its workers and employees related to the work and operations of the same, and these, in turn, can publish in such boards the same type of ads, news and notices. These boards do not include notices that are not strictly related to the work of the workplace.',
            'NOT6':'6. To promote decent work and achieve a favorable organizational environment, this work center makes an adequate distribution of workloads, with working hours in accordance with the Federal Labor Law, for this purpose, defined in the organization manuals and in the job descriptions that are issued, as well as in the Internal Labor Regulations, depending on the specific nature of the work in question.',
            'NOT7':'7. To recognize the performance of workers in the workplace, the performance of each of their workers and employees is evaluated at least once a year, which is carried out personally through the supervisor or immediate head of the The worker or employee in question and the results thereof serve as the basis for determining recognition or benefits to outstanding workers.',
            'NOT8':'8. This work center undertakes to monitor compliance with the norms aimed at preventing any conduct or behavior that involves labor violence, to safeguard the information that is collected, to process and intervene, in a timely manner, in the complaints that are received by established means.',
          }
        }
      },
      'Guia5':{
        'TITLE':'Reference Guide V',
        'SUBTITLE':'WORKER DATA',
        'DES':'The content of this guide is a complement to the better understanding of this Standard, and is not mandatory',
        'CONTENT':{
          'TITLE':'Worker Information',
          'LABEL01':'Sex:',
          'LABEL02':'Male:',
          'LABEL03':'Female:',
          'LABEL04':'Age in years: ',
          'LABELYEAR01':'years',
          'LABELYEAR02':'or more',
          'ESTADO':{
              'TITLE': 'Marital status:',
               'LABEL01': 'Married',
               'LABEL02': 'Single',
               'LABEL03': 'Free union',
               'LABEL04': 'Divorced',
               'LABEL05': 'Widower'
          },
          'ESTUDIOS':{
               'TITLE': 'Level of studies',
               'LABEL01': 'No information',
               'LABEL02': 'Primary',
               'LABEL03': 'Secondary',
               'LABEL04': 'Preparatory or Baccalaureate',
               'LABEL05': 'Senior Technician',
               'LABEL06': 'Bachelor',
               'LABEL07': 'Master',
               'LABEL08': 'Doctorate',
               'OPC1': 'Finished',
               'OPC2': 'Incomplete',
          },
           'LABEL05': 'Labor data:',
           'LABEL06': 'Occupation / Profession / Position:',
           'LABEL07': 'Department / Section / Area:',
          'PUESTO':{
            'TITLE': 'Type of position:',
             'LABEL01': 'Operational',
             'LABEL02': 'Supervisor',
             'LABEL03': 'Professional',
             'LABEL04': 'Manager',
          },
          'CONTRATACION':{
               'TITLE': 'Type of contract:',
               'LABEL01': 'By work or project',
               'LABEL02': 'Indeterminate time',
               'LABEL03': 'Professional or technical',
               'LABEL04': 'Schedules',
          },
          'PERSONAL':{
            'TITLE': 'Type of personnel:',
               'LABEL01': 'Syndicated',
               'LABEL02': 'None',
               'LABEL03': 'Trust',
          },
          'JORNADA':{
             'TITLE':'Type of workday:',
             'LABEL01': 'Fixed at night (between 8:00 p.m. and 6:00 a.m.)',
             'LABEL02': 'Fixed mixed (combination of night and day)',
             'LABEL03': 'Fixed daytime (between 6:00 AM and 8:00 PM)',
          },
          'ROTACION':{
            'TITLE': 'Perform shift rotation:',
               'OPC1': 'YES',
               'OPC2': 'NO'
          },
          'EXPERIENCIA':{
               'TITLE': 'Experience (years):',
               'SUBTITLE': 'Time in the current position:',
               'LABEL01': 'Less than 6 months',
               'LABEL02': 'Between 6 months and 1 year',
               'LABEL03': 'Between 1 to 4 years',
               'LABEL04': 'Between 5 to 9 years',
               'LABEL05': 'Between 10 to 14 years',
               'LABEL06': 'Between 15 to 19 years',
               'LABEL07': 'Between 20 to 24 years old',
               'LABEL08': '25 years or more',
               'LABELIN': 'Work experience time:',
               'LABEL09': 'Less than 6 months',
               'LABEL10': 'Between 6 months and 1 year',
               'LABEL11': 'Between 1 to 4 years',
               'LABEL12': 'Between 5 to 9 years',
               'LABEL13': 'Between 10 to 14 years',
               'LABEL14': 'Between 15 to 19 years',
               'LABEL15': 'Between 20 to 24 years old',
               'LABEL16': '25 years or more'

          },

          }

      },
    }
  }
};
